var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"logsTableModal",attrs:{"id":"logs-tables-dialog","modal-class":_vm.theme,"hide-footer":"","centered":"","body-class":"modal__confirm","size":"xl"}},[_c('LogsTable',{attrs:{"logsA":_vm.logs,"logsFilterTable":_vm.logsFilter}}),_c('ErrorDialog',{ref:"errDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }